// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Fjof","title":"AfterBackImages_title__2Ielu","images":"AfterBackImages_images__qmEIm"};